import React, {useState} from "react";
import { t } from "../../../../../utils/i18n";

const BankAccountDetails = ({
  isBuyer,
  instructionsFrom,
  sellerUsername,
  tradeBankAccount,
  transferTotal,
  referenceMessage,
  buyerName,
}) => {
  const [copied, setCopied] = useState(null);

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopied(field);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div>
        <p className="tradedetails-tradeinfo-title">
        <i className="fas fa-info-circle"></i>
        {" "}{isBuyer ? t("p2p.details.sellers_instr") : t("p2p.details.my_instr")}
        </p>
        <div>
          <div>
            <div>
              <div>
                {isBuyer ? (
                  <p
                    className="tradedetails-instructions-from"
                    dangerouslySetInnerHTML={{ __html: t("p2p.details.use_details_html") }}
                  />
                ) : (
                  <p
                    className="tradedetails-instructions-from"
                    dangerouslySetInnerHTML={{ __html: t("p2p.details.confirm_details_html") }}
                  />
                )}
                <div className="bank_details">
                  {tradeBankAccount?.bankName && tradeBankAccount?.bankName !== "Other" && (
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.bank_table.bank_name_colon")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.bankName}
                          <button onClick={() => handleCopy(tradeBankAccount?.bankName, "tradeBankAccount?.bankName")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "tradeBankAccount?.bankName" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                    )}
                    {tradeBankAccount?.customBankDetails && (
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.bank_table.bank_name_colon")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.customBankDetails}
                          <button onClick={() => handleCopy(tradeBankAccount?.customBankDetails, "tradeBankAccount?.customBankDetails")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "tradeBankAccount?.customBankDetails" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                    )}
                  {tradeBankAccount?.accountHolderName && (
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.account_title")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.accountHolderName}
                          <button onClick={() => handleCopy(tradeBankAccount?.accountHolderName, "tradeBankAccount?.accountHolderName")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "tradeBankAccount?.accountHolderName" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                  )}
                  {!tradeBankAccount?.ibanNumber && tradeBankAccount?.accountNumber && (
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.account_number")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.accountNumber}
                          <button onClick={() => handleCopy(tradeBankAccount?.accountNumber, "tradeBankAccount?.accountNumber")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "tradeBankAccount?.accountNumber" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                  )}
                      {tradeBankAccount?.routingNumber && (
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                          <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.routing")}</label>
                          <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.routingNumber}
                            <button onClick={() => handleCopy(tradeBankAccount?.routingNumber, "tradeBankAccount?.routingNumber")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "tradeBankAccount?.routingNumber" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                          </span>
                        </div>
                      )}
                      {tradeBankAccount?.interacEmail && (
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                          <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.interac")}</label>
                          <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.interacEmail}
                            <button onClick={() => handleCopy(tradeBankAccount?.interacEmail, "tradeBankAccount?.interacEmail")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "tradeBankAccount?.interacEmail" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                          </span>
                        </div>
                      )}
                      {tradeBankAccount?.swiftCode && (
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                          <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.swift")}</label>
                          <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.swiftCode}
                            <button onClick={() => handleCopy(tradeBankAccount?.swiftCode, "tradeBankAccount?.swiftCode")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "tradeBankAccount?.swiftCode" ? "check" : "copy"}`}   title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                          </span>
                        </div>
                      )}
                      {tradeBankAccount?.ibanNumber && (
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                          <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.iban")}</label>
                          <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.ibanNumber}
                            <button onClick={() => handleCopy(tradeBankAccount?.ibanNumber, "tradeBankAccount?.ibanNumber")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "tradeBankAccount?.ibanNumber" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                          </span>
                        </div>
                      )}
                      {tradeBankAccount?.clabe && (
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                         <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.clabe")}</label>
                         <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.clabe}
                            <button onClick={() => handleCopy(tradeBankAccount?.clabe, "tradeBankAccount?.clabe")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "tradeBankAccount?.clabe" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                         </span>
                        </div>
                      )}
                      {tradeBankAccount?.country?.name && (
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                          <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.country")}</label>
                          <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.country?.name}
                            <button onClick={() => handleCopy(tradeBankAccount?.country?.name, "tradeBankAccount?.country?.name")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "tradeBankAccount?.country?.name" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                          </span>
                        </div>
                      )}
                      {tradeBankAccount?.fiatCurrency?.code && (
                        <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                          <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.currency")}</label>
                          <span className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.fiatCurrency?.code}
                            <button onClick={() => handleCopy(tradeBankAccount?.fiatCurrency?.code, "tradeBankAccount?.fiatCurrency?.code")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "tradeBankAccount?.fiatCurrency?.code" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                          </span>
                        </div>
                      )}
                      {
                        tradeBankAccount?.error && (
                          <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                            <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.bank_details")}</label>
                            <p className="tradedetails-tradeinfo-payment-textvalues">{tradeBankAccount?.error}</p>
                          </div>
                        )
                      }
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames" title={t("p2p.details.ref_tip")}>{t("p2p.details.tx_ref")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{referenceMessage || "hands polish"}
                            <button onClick={() => handleCopy(referenceMessage || "hands polish", "referenceMessage")} className="tradedetails-copybtn">
                              <i className={`fas fa-${copied === "referenceMessage" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                            </button>
                        </span>
                      </div>
                      <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                        <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.total")}</label>
                        <span className="tradedetails-tradeinfo-payment-textvalues">{transferTotal}
                          <button onClick={() => handleCopy(transferTotal, "transferTotal")} className="tradedetails-copybtn">
                            <i className={`fas fa-${copied === "transferTotal" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>            
                </div>
              </div>
            </div>
          </div>
      <div>
        <p className="tradedetails-tradeinfo-title">
          <i className="fas fa-info-circle"></i>
          {isBuyer ? t("p2p.details.sellers_details") : t("p2p.details.buyers_details")}
        </p>
        <div>
          <div>
            <div>
              <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.common.name_colon")}</label>
                <span className="tradedetails-tradeinfo-payment-textvalues">{isBuyer ? sellerUsername : buyerName}</span>
              </div>
              <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                <label className="tradedetails-tradeinfo-payment-textnames">{t("p2p.details.total")}</label>
                <span className="tradedetails-tradeinfo-payment-textvalues">{transferTotal}
                  <button onClick={() => handleCopy(transferTotal, "transferTotal")} className="tradedetails-copybtn">
                    <i className={`fas fa-${copied === "transferTotal" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                  </button>
                </span>
              </div>
              <div className="trade_bank_account tradedetails-tradeinfo-specifics-text">
                <label className="tradedetails-tradeinfo-payment-textnames" title={t("p2p.details.ref_tip")}>{t("p2p.details.tx_ref")}</label>
                <span className="tradedetails-tradeinfo-payment-textvalues">{referenceMessage || "hands polish"}
                  <button onClick={() => handleCopy(referenceMessage || "hands polish", "referenceMessage")} className="tradedetails-copybtn">
                    <i className={`fas fa-${copied === "referenceMessage" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BankAccountDetails;
